import { DASHBOARD_API_CALL_TYPE } from 'helpers/sf_constants';
import { parseDashboardAPIPayload } from 'helpers/sf_dashboard_helper';
import {
  GET_DASHBOARD_DATA,
  GET_DASHBOARD_DATA_SUCCESS,
  GET_DASHBOARD_DATA_ERROR,

  LEADS_GET_DASHBOARD_DATA,
  LEADS_GET_DASHBOARD_DATA_ERROR,
  LEADS_GET_DASHBOARD_DATA_SUCCESS,

  CALLS_GET_DASHBOARD_DATA,
  CALLS_GET_DASHBOARD_DATA_SUCCESS,
  CALLS_GET_DASHBOARD_DATA_ERROR,
  RESET_DASHBOARD_ERROR,
} from './actionTypes';

const INIT_STATE = {
  main_data: {},
  state_wise_metrics: [],
  source_type_wise_metrics: [],
  creative_wise_metrics: [],
  conversion_pixel_wise_metrics: [],
  campaign_wise_metrics: [],
  date_ranges: [],
  compare_to_main_data: [],
  insurance_type_wise_metrics: [],

  //Leads related
  leads_main_data: {},
  leads_state_wise_metrics: [],
  leads_campaign_wise_metrics: [],
  leads_date_ranges: [],
  leads_compare_to_main_data: [],
  leads_insurance_type_wise_metrics: [],

  //Calls related
  calls_main_data: {},
  calls_state_wise_metrics: [],
  calls_campaign_wise_metrics: [],
  calls_date_ranges: [],
  calls_compare_to_main_data: [],
  calls_insurance_type_wise_metrics: [],



  loading: {
    [DASHBOARD_API_CALL_TYPE.FETCH_MAIN_DATA]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_STATE_WISE_METRICS]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_CREATIVE_WISE_METRICS]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_SOURCE_TYPE_WISE_METRICS]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_CONVERSION_PIXEL_WISE_METRICS]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_CAMPAIGN_WISE_METRICS]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_DATE_RANGES]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_COMPARE_TO_MAIN_DATA]: false,
    //For Lead types
    [DASHBOARD_API_CALL_TYPE.FETCH_LEADS_MAIN_DATA]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_LEADS_CAMPAIGN_WISE_METRICS]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_LEADS_COMPARE_TO_MAIN_DATA]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_LEADS_DATE_RANGES]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_LEADS_STATE_WISE_METRICS]: false,

    //For Call types
    [DASHBOARD_API_CALL_TYPE.FETCH_CALLS_MAIN_DATA]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_CALLS_DATE_RANGES]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_CALLS_CAMPAIGN_WISE_METRICS]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_CALLS_COMPARE_TO_MAIN_DATA]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_CALLS_STATE_WISE_METRICS]: false,

  },
  error: {
    [DASHBOARD_API_CALL_TYPE.FETCH_MAIN_DATA]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_STATE_WISE_METRICS]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_CREATIVE_WISE_METRICS]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_SOURCE_TYPE_WISE_METRICS]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_CONVERSION_PIXEL_WISE_METRICS]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_CAMPAIGN_WISE_METRICS]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_DATE_RANGES]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_COMPARE_TO_MAIN_DATA]: null,

    //For Lead types
    [DASHBOARD_API_CALL_TYPE.FETCH_LEADS_MAIN_DATA]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_LEADS_CAMPAIGN_WISE_METRICS]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_LEADS_COMPARE_TO_MAIN_DATA]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_LEADS_DATE_RANGES]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_LEADS_STATE_WISE_METRICS]: null,

    //For Call types
    [DASHBOARD_API_CALL_TYPE.FETCH_CALLS_MAIN_DATA]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_CALLS_DATE_RANGES]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_CALLS_CAMPAIGN_WISE_METRICS]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_CALLS_COMPARE_TO_MAIN_DATA]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_CALLS_STATE_WISE_METRICS]: null,

  },
  last_query_time: null,

};
let time = 0;

const apiTypeToReducerField = (api_type) => {
  return api_type.replace('fetch_', '');
}

const apiTypeToReducerFieldLeads = (api_type) => {
  return api_type.replace('fetch_leads_', '');
}

const apiTypeToReducerFieldCalls = (api_type) => {
  return api_type.replace('fetch_calls_', '');
}

const Dashboard = (state = INIT_STATE, action) => {
  function clearQueryTime() {
    state = {
      ...state,
      last_query_time: null,
    };
  }
  switch (action.type) {
    case GET_DASHBOARD_DATA:
      time = performance.now();
      return {
        ...state,
        error: null,
        main_data: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_MAIN_DATA ? [] : state.main_data,
        state_wise_metrics: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_STATE_WISE_METRICS ? [] : state.state_wise_metrics,
        source_type_wise_metrics: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_SOURCE_TYPE_WISE_METRICS ? [] : state.source_type_wise_metrics,
        creative_wise_metrics: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_CREATIVE_WISE_METRICS ? [] : state.creative_wise_metrics,
        conversion_pixel_wise_metrics: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_CONVERSION_PIXEL_WISE_METRICS ? [] : state.conversion_pixel_wise_metrics,
        campaign_wise_metrics: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_CAMPAIGN_WISE_METRICS ? [] : state.campaign_wise_metrics,
        insurance_type_wise_metrics: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_INSURNCE_TYPE_WISE_METRICS ? [] : state.insurance_type_wise_metrics,

        date_ranges: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_DATE_RANGES ? [] : state.date_ranges,
        compare_to_main_data: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_COMPARE_TO_MAIN_DATA ? [] : state.compare_to_main_data,


        loading: {
          ...state.loading, [action.api_type]: true
        },
        last_query_time: null,
      };

    case GET_DASHBOARD_DATA_SUCCESS:
      // setTimeout(clearQueryTime, 2000);
      time = (performance.now() - time) / 1000;
      return {
        ...state,
        error: null,
        [apiTypeToReducerField(action.api_type)]: parseDashboardAPIPayload(action.payload[apiTypeToReducerField(action.api_type)], action.api_type),
        loading: {
          ...state.loading,
          [action.api_type]: false
        },
        last_query_time: time.toFixed(2),

      };

    case GET_DASHBOARD_DATA_ERROR:
      return {
        ...state,
        // TODO: Error handling
        error: action.payload,
        loading: false,
      };

    //Leads
    case LEADS_GET_DASHBOARD_DATA:
      time = performance.now();
      return {
        ...state,
        error: null,

        leads_main_data: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_LEADS_MAIN_DATA ? [] : state.leads_main_data,
        leads_state_wise_metrics: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_LEADS_STATE_WISE_METRICS ? [] : state.leads_state_wise_metrics,
        leads_date_ranges: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_LEADS_DATE_RANGES ? [] : state.leads_date_ranges,
        leads_compare_to_main_data: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_LEADS_COMPARE_TO_MAIN_DATA ? [] : state.leads_compare_to_main_data,
        leads_campaign_wise_metrics: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_LEADS_CAMPAIGN_WISE_METRICS ? [] : state.leads_campaign_wise_metrics,
        leads_insurance_type_wise_metrics: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_LEADS_INSURANCE_TYPE_WISE_METRICS ? [] : state.leads_insurance_type_wise_metrics,

        loading: {
          ...state.loading, [action.api_type]: true
        },
        last_query_time: null,
      };

    case LEADS_GET_DASHBOARD_DATA_SUCCESS:
      time = (performance.now() - time) / 1000;
      return {
        ...state,
        error: null,
        [apiTypeToReducerField(action.api_type)]: parseDashboardAPIPayload(action.payload[apiTypeToReducerFieldLeads(action.api_type)], action.api_type),
        loading: {
          ...state.loading,
          [action.api_type]: false
        },
        last_query_time: time.toFixed(2),

      };

    case LEADS_GET_DASHBOARD_DATA_ERROR:
      return {
        ...state,
        // TODO: Error handling
        error: action.payload,
        loading: false,
      };


    //Calls
    case CALLS_GET_DASHBOARD_DATA:
      time = performance.now();
      return {
        ...state,
        error: null,

        calls_main_data: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_CALLS_MAIN_DATA ? [] : state.calls_main_data,
        calls_state_wise_metrics: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_CALLS_STATE_WISE_METRICS ? [] : state.calls_state_wise_metrics,
        calls_date_ranges: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_CALLS_DATE_RANGES ? [] : state.calls_date_ranges,
        calls_compare_to_main_data: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_CALLS_COMPARE_TO_MAIN_DATA ? [] : state.calls_compare_to_main_data,
        calls_campaign_wise_metrics: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_CALLS_CAMPAIGN_WISE_METRICS ? [] : state.calls_campaign_wise_metrics,
        calls_insurance_type_wise_metrics: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_CALLS_INSURANCE_TYPE_WISE_METRICS ? [] : state.calls_insurance_type_wise_metrics,

        loading: {
          ...state.loading, [action.api_type]: true
        },
        last_query_time: null,
      };

    case CALLS_GET_DASHBOARD_DATA_SUCCESS:
      // setTimeout(clearQueryTime, 2000);
      time = (performance.now() - time) / 1000;
      return {
        ...state,
        error: null,
        [apiTypeToReducerField(action.api_type)]: parseDashboardAPIPayload(action.payload[apiTypeToReducerFieldCalls(action.api_type)], action.api_type),
        loading: {
          ...state.loading,
          [action.api_type]: false
        },
        last_query_time: time.toFixed(2),

      };

    case CALLS_GET_DASHBOARD_DATA_ERROR:
      return {
        ...state,
        // TODO: Error handling
        error: action.payload,
        loading: false,
      };

    case RESET_DASHBOARD_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export default Dashboard;
